
// @ts-nocheck


export const localeCodes =  [
  "nl",
  "de"
]

export const localeLoaders = {
  nl: [
    {
      key: "locale_nl_46json_8350436f",
      load: () => import("#nuxt-i18n/8350436f" /* webpackChunkName: "locale_nl_46json_8350436f" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_16c35c61",
      load: () => import("#nuxt-i18n/16c35c61" /* webpackChunkName: "locale_de_46json_16c35c61" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/a0a02eec" /* webpackChunkName: "config_i18n_46config_46js_a0a02eec" */)
]

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      name: "nederlands",
      code: "nl",
      language: "nl-NL",
      domain: "https://www.kotterliving.nl",
      files: [
        "/tmp/build_c575918f/src/assets/i18n/nl.json"
      ]
    },
    {
      name: "deutsch",
      code: "de",
      language: "de-DE",
      domain: "https://www.koetterliving.de",
      files: [
        "/tmp/build_c575918f/src/assets/i18n/de.json"
      ]
    }
  ],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "assets/i18n/",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: true,
  baseUrl: "https://www.koetterliving.de",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    name: "nederlands",
    code: "nl",
    language: "nl-NL",
    domain: "https://www.kotterliving.nl",
    files: [
      {
        path: "/tmp/build_c575918f/src/assets/i18n/nl.json",
        cache: undefined
      }
    ]
  },
  {
    name: "deutsch",
    code: "de",
    language: "de-DE",
    domain: "https://www.koetterliving.de",
    files: [
      {
        path: "/tmp/build_c575918f/src/assets/i18n/de.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/